const {
    SOURCE_MFFV_1_MMB,
  } = require('./../../../../sourceList'),
  {
    ARMOR_TYPE_NATURAL,
  } = require('./../../../../armorTypeList'),
  {
    CR_3,
  } = require('./../../../../crList'),
  {
    SIZE_MEDIUM,
  } = require('./../../../../sizeList'),
  {
    CREATURE_TYPE_MONSTROSITY,
  } = require('./../../../../creatureTypeIdList'),
  {
    SKILL_ACROBATICS,
    SKILL_ATHLETICS,
    SKILL_PERCEPTION,
  } = require('./../../../../skillList'),
  {
    LANG_COMMON,
  } = require('./../../../../languageIdList'),
  {
    ALIGNMENT_CE,
  } = require('./../../../../aligmentList'),
  {
    SPEED_WALK,
  } = require('./../../../../speedList'),
  {
    ATTACK_MELEE_WEAPON,
  } = require('./../../../../attackTypeList'),
  {
    DAMAGE_PIERCING,
  } = require('./../../../../damageTypeList'),
  {
    SENSE_DARK_VISION,
  } = require('./../../../../senseList'),
  {
    PARAM_STR,
    PARAM_DEX,
    PARAM_CON,
    PARAM_INT,
    PARAM_WIT,
    PARAM_CHA,
  } = require('./../../../../paramList'),
  {
    ABILITY_ETHEREAL_JAUNT,
  } = require('./../../../../creatureAbilityList'),
  {
    PROF_DOUBLE,
    PROF_NORMAL,
  } = require('./../../../../proficiencyList'),
  {
    CREATURE_XILL,
  } = require('./../../../../creatureIdList')

module.exports = {
  name: 'Зилль',
  nameEn: 'Xill',
  id: CREATURE_XILL,
  description: `Глубоко в Эфирном Плане существуют демипланы, миниатюрные миры, построенные могущественными архимагами и другими могущественными сущностями, как личные владения. Каждый демиплан — это маленький мир, спроектированный для конкретной цели. Некоторые из них — крепости, предназначенные для того, чтобы отгородиться от проходимцев с Материального плана. Другие - гораздо более зловещие, тёмные царства, где злые мысли укореняются и становятся жуткой реальностью. Как раз такое место и породило зиллей — ужасных, насекомоподобных существ, очень давно созданных древним злым хозяином себе на службу.

**Жуткие собиратели.** Зилли — жуткие четырёхрукие существа, которые выглядят чем-то средним между ящерицей и насекомым. Они выходят из Эфирного Плана чтобы кромсать жертв ужасными когтями. Но их цель — не убивать. Вместо этого зилль вводит жертве паралитический яд. Когда яд сокрушает цель, зилль хватает жертву и возвращается на Эфирный План. Окончательная судьба несчастных, унесённых таким образом, неизвестна, и истинная природа зиллей и породившего их демиплана окружены множеством предположений и гипотез.

**Пережитки древности.** Разнообразные теории пытаются объяснить зиллей и их происхождение. Одна из них, считающаяся среди планарных исследователей наиболее правдоподобной, говорит о неком загадочном волшебнике Кераптисе. Предположительно, в древние времена Кераптис создал демиплан, который бы служил его личным владением. Оттуда он мог посылать слуг собирать могущественные артефакты, которые он жаждал заполучить. Зилли были его созданием, слугами, которые могли ускользать на Эфирный план и обратно и украсть любой артефакт или похитить любого человека, которые ему были нужны.

**Загадочная цель.** Мало что известно о Керпатисе. Не считая недавней кражи трёх могущественных предметов в мире Серого Ястреба, он оставался в первую очередь мифической фигурой, достоянием слухов и легенд. Тем не менее, будучи заядлым коллекционером магических предметов, он, вероятно, заполнил свой демиплан могущественными артефактами, которые долго давно считаются утерянными в Мультивселенной. Если эта история правдива, его демиплан, несомненно, охраняется странными ловушками и не поддающимися логике головоломками, вместе с легионом слуг с промытыми мозгами и бесчисленных зиллей. Что касается судьбы лиц, захваченных зиллями, то они, возможно, составляют основную часть последователей Керпатиса. Фанатики с промытые магией мозгами, охраняющие его многочисленные подземелья. Они — одни из самых опасных его последователей. Говорят что зилли редко похищают простых людей. Вместо этого они нацелены на молодых, но многообещающих приключенцев, тех, чей природный талант и способности указывают на светлое будущее, но чьи навыки ещё не столь отточены, чтобы отразить внезапное нападение.`,
  sizeType: SIZE_MEDIUM,
  creatureTypeIdList: [
    CREATURE_TYPE_MONSTROSITY,
  ],
  alignmentId: ALIGNMENT_CE,
  source: {
    id: SOURCE_MFFV_1_MMB,
    page: 21,
  },
  armor: {
    ac: 16,
    type: ARMOR_TYPE_NATURAL,
  },
  hp: {
    diceCount: 6,
  },
  speed: {
    [SPEED_WALK]: 40,
  },
  params: {
    [PARAM_STR]: 14,
    [PARAM_DEX]: 18,
    [PARAM_CON]: 13,
    [PARAM_INT]: 11,
    [PARAM_WIT]: 14,
    [PARAM_CHA]: 9,
  },
  skillCollection: {
    [SKILL_ACROBATICS]: PROF_NORMAL,
    [SKILL_ATHLETICS]: PROF_NORMAL,
    [SKILL_PERCEPTION]: PROF_NORMAL,
  },
  senseList: [
    {
      id: SENSE_DARK_VISION,
      value: 60,
    },
  ],
  languageList: [
    LANG_COMMON,
  ],
  cr: CR_3,
  featureList: [
    ABILITY_ETHEREAL_JAUNT,
    {
      name: 'Ядовитое жало',
      description: `★СУЩЕСТВО★ впрыскивает яд в одно существо, по которому он попал атакой _Когтями_ на своём ходу. Выбранное существо должно пройти испытание Телосложения СЛ 11. Существо получает помеху к этому испытанию, если ★СУЩЕСТВО★ ★попал★ по нему больше одного раза на этом ходу.

При провале существо получает 14 (4к6) урона ядом или половину этого урона при успехе. Существо, хиты которого опускаются до 0 от этого яда, остаётся стабилизированным, но отравленным на 1 час, даже если восстановит хиты, и, пока оно отравлено из-за этого, оно ещё и парализовано`,
    },
  ],
  actionList: [
    {
      name: 'Мультиатака',
      description: `★СУЩЕСТВО★ совершает четыре атаки _Когтями_.`,
    },
    {
      name: 'Когти',
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 6,
        range: 5,
        hit: {
          type: DAMAGE_PIERCING,
          diceCount: 1,
          diceType: 4,
          diceBonus: 4,
        },
      },
    },
  ],
}
